// extracted by mini-css-extract-plugin
export var avatarContainer = "_5f-0";
export var avatarTypingWave = "_5f-i";
export var gray = "_5f-f";
export var green = "_5f-c";
export var icon = "_5f-9";
export var image = "_5f-1";
export var lg = "_5f-6";
export var md = "_5f-5";
export var presenceDot = "_5f-b";
export var red = "_5f-d";
export var sm = "_5f-4";
export var status = "_5f-a";
export var typingDot = "_5f-h";
export var typingPill = "_5f-g";
export var xl = "_5f-7";
export var xs = "_5f-3";
export var xxl = "_5f-8";
export var xxs = "_5f-2";
export var yellow = "_5f-e";